// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"682fb399","311":"7baff137","569":"7384e01a"}[chunkId] + ".chunk.js";
};